import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import MyReviewCase from './my-review-case'
import MyReviewCaseModify from './my-review-case-modify'

export default class ReviewCase extends Component {
    render() {
        return (
            <Switch>
                <Route path='/fixcomputer/reviewcase' component={MyReviewCase} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/fixcomputer/reviewcase/modify' component={MyReviewCaseModify} />
                <Redirect to='/fixcomputer/reviewcase' />
            </Switch>
        )
    }
}